import React from "react";
import { DepositBonus } from "@/features/wallet/components/DepositBonus";
import { useDepositWizard } from "@/features/wallet/components/deposit/hooks/useDepositWizard";
import * as styles from "./DepositContent.module.scss";

const DepositContentLayout = ({
  depositAmountInCents,
  children,
}: {
  depositAmountInCents: number;
  children: React.ReactNode;
}) => {
  return (
    <div className={styles.container}>
      <DepositBonus compact depositAmount={depositAmountInCents} />
      {children}
    </div>
  );
};

/**
 * For stand-ins that render before the wizard mounts, where there is no amount
 * to read. The bonus banner needs the amount rather than the wizard itself, so
 * it still occupies its settled height.
 */
export const DepositContentSkeleton = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <DepositContentLayout depositAmountInCents={0}>
      {children}
    </DepositContentLayout>
  );
};

export const DepositContent = ({ children }: { children: React.ReactNode }) => {
  const { amount } = useDepositWizard();

  return (
    <DepositContentLayout depositAmountInCents={Math.round(amount * 100)}>
      {children}
    </DepositContentLayout>
  );
};
